export default __webpack_public_path__ + "static/media/mushrooms.5e78740e.png";